import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CircularProgress,
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

import { Modal, ModalProps } from 'modules/ui/modal';
import { Alert } from 'modules/ui/alert';

import { CallLinksToken } from '../interfaces';
import axios from 'axios';
import { callRecordingUrl } from '../hooks/crud';

interface Props extends ModalProps {
  callTokens: CallLinksToken;
  recordingId?: string | null;
  transcriptData?: Record<string, any>[] | null;
}

export const CallLinksModal = ({ open, onClose, callTokens, recordingId, transcriptData }: Props) => {
  const { t } = useTranslation('common');
  const location = useMemo(() => window.location.origin, []);
  const [recordingUrl, setRecordingUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchRecordingUrl = async () => {
    if (!recordingId || recordingUrl || loading) return;
    setLoading(true);
    try {
      const data = await callRecordingUrl(recordingId);
      setRecordingUrl(data.recording_url);
    } catch (err) {
      console.error('Failed to load recording URL:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} title={t('call.links.title')}>
      <Box mt={1}>
        <Typography variant="h4" mb={1}>
          {t('call.links.technicianLink')}:
        </Typography>
        <Alert
          message={`${location}/room/${callTokens.technician_token}`}
          severity="info"
          icon={<></>}
        />
      </Box>

      <Box mt={3}>
        <Typography variant="h4" mb={1}>
          {t('call.links.customerLink')}:
        </Typography>
        <Alert
          message={`${location}/call/${callTokens.client_token}`}
          severity="warning"
          icon={<></>}
        />
      </Box>

    </Modal>
  );
};
